import { Injectable, signal } from '@angular/core';

/**
 * Layout Service
 * Verwaltet den globalen UI-State der Anwendung
 */
@Injectable({
  providedIn: 'root',
})
export class Layout {
  readonly isProjectNavOpen = signal<boolean>(false);

  openProjectNav() {
    this.isProjectNavOpen.set(true);
  }

  closeProjectNav() {
    this.isProjectNavOpen.set(false);
  }

  toggleProjectNav() {
    this.isProjectNavOpen.update(v => !v);
  }

  resetAll() {
    this.isProjectNavOpen.set(false);
  }
}
